module.exports = __webpack_public_path__ + "static/media/shipping details.4d920cd7.png";